import React, { memo } from 'react';

export const NightMap = memo(() => (
  <div className="FreeTrial__NightMap" aria-hidden="true">
    <svg className="FreeTrial__NightMap__Wide" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="trial-dots" width="22" height="22" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.2" fill="#c7d2fe" fillOpacity=".14" />
        </pattern>
      </defs>
      <rect width="1440" height="900" fill="url(#trial-dots)" />
      <path
        d="M0 0H300C340 130 280 230 350 330C420 430 320 520 380 610C440 700 390 800 450 900H0Z"
        fill="#0b1030"
      />
      <path
        d="M330 420C520 395 700 470 940 430C1090 405 1250 445 1440 420"
        stroke="#0b1030"
        strokeWidth="38"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M380 610C560 650 760 590 1000 625C1150 645 1300 610 1440 630"
        stroke="#0b1030"
        strokeWidth="22"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M420 0C470 160 560 240 700 300C860 370 1000 330 1120 250C1220 180 1330 160 1440 170"
        stroke="#c7d2fe"
        strokeOpacity=".2"
        strokeWidth="3"
        fill="none"
      />
      <path
        d="M500 900C540 760 640 700 760 690C900 680 1040 740 1180 720C1300 700 1380 640 1440 600"
        stroke="#c7d2fe"
        strokeOpacity=".2"
        strokeWidth="3"
        fill="none"
      />
      <path
        d="M820 0C800 120 860 220 840 330C820 460 900 560 880 900M1100 0C1080 200 1180 320 1160 500C1150 650 1220 760 1200 900"
        stroke="#c7d2fe"
        strokeOpacity=".12"
        strokeWidth="2"
        fill="none"
      />
    </svg>
    <svg className="FreeTrial__NightMap__Phone" viewBox="0 0 390 844" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="trial-dots-phone" width="20" height="20" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.1" fill="#c7d2fe" fillOpacity=".14" />
        </pattern>
      </defs>
      <rect width="390" height="844" fill="url(#trial-dots-phone)" />
      <path d="M0 0H60C76 110 40 210 66 320C90 420 46 520 70 640C84 720 60 790 76 844H0Z" fill="#0b1030" />
      <path
        d="M60 300C140 284 220 330 300 306C340 294 370 300 390 296"
        stroke="#0b1030"
        strokeWidth="22"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M70 640C150 664 230 626 320 646C350 652 372 648 390 644"
        stroke="#0b1030"
        strokeWidth="14"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M110 0C130 140 180 220 250 250C320 280 360 250 390 240M150 844C170 740 230 700 300 696C340 694 370 680 390 668"
        stroke="#c7d2fe"
        strokeOpacity=".2"
        strokeWidth="2"
        fill="none"
      />
    </svg>
    <span className="FreeTrial__NightMap__Star FreeTrial__NightMap__Star--a" />
    <span className="FreeTrial__NightMap__Star FreeTrial__NightMap__Star--b" />
    <span className="FreeTrial__NightMap__Star FreeTrial__NightMap__Star--c" />
    <span className="FreeTrial__NightMap__Star FreeTrial__NightMap__Star--d" />
  </div>
));
